import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UrlSlugifyService {

  constructor() { }

  slugify(text: string): string {
    return text
      .toLowerCase()
      .replace(/\s+/g, '-')                      
      .replace(/[^a-z0-9\u0600-\u06FF\-]+/g, '')  
      .replace(/\-+/g, '-')                      
      .replace(/^-+|-+$/g, '');                  
  }
}
